// Entity-type chip tone palette + icons. Pure design tokens used by the
// EntityChip leaf and its story. The rgba() literals here are the entity-type
// tone palette (semantic per-type accents), not arbitrary hardcoded colors.

import { MapPin, Radio, Smartphone } from 'lucide-react'
import type React from 'react'

export type KnownEntityType =
  | 'BTSStation'
  | 'MobileDevice'
  | 'PhoneNumber'
  | 'Person'
  | 'SocialAccount'
  | 'Location'

export const ENTITY_TONE: Record<string, { bg: string; color: string; border: string }> = {
  BTSStation: {
    bg: 'rgba(224, 144, 80, 0.14)',
    color: '#e09050',
    border: 'rgba(224, 144, 80, 0.45)',
  },
  MobileDevice: {
    bg: 'rgba(179, 156, 255, 0.14)',
    color: '#b39cff',
    border: 'rgba(179, 156, 255, 0.40)',
  },
  PhoneNumber: {
    bg: 'rgba(179, 156, 255, 0.14)',
    color: '#b39cff',
    border: 'rgba(179, 156, 255, 0.40)',
  },
  Person: {
    bg: 'rgba(111, 227, 212, 0.14)',
    color: '#6fe3d4',
    border: 'rgba(111, 227, 212, 0.40)',
  },
  SocialAccount: {
    bg: 'rgba(255, 176, 82, 0.14)',
    color: '#ffb052',
    border: 'rgba(255, 176, 82, 0.40)',
  },
  Location: {
    bg: 'rgba(139, 227, 139, 0.14)',
    color: '#8be38b',
    border: 'rgba(139, 227, 139, 0.40)',
  },
}

export const DEFAULT_ENTITY_TONE = {
  bg: 'rgba(143, 153, 168, 0.14)',
  color: '#8e96a4',
  border: 'rgba(143, 153, 168, 0.40)',
}

export function entityTone(label: string) {
  return ENTITY_TONE[label] ?? DEFAULT_ENTITY_TONE
}

export const ENTITY_ICON: Record<KnownEntityType, React.ReactNode> = {
  BTSStation: <Radio size={11} />,
  MobileDevice: <Smartphone size={11} />,
  PhoneNumber: <Smartphone size={11} />,
  Person: <Smartphone size={11} />,
  SocialAccount: <Smartphone size={11} />,
  Location: <MapPin size={11} />,
}
